import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/src/app/globals.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/dist/index.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/packages/ui/src/navigation/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/packages/ui/src/signUpSideBySide/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SmoothScroll"] */ "/vercel/path0/packages/ui/src/smoothScroll/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WebSocketCleanup"] */ "/vercel/path0/packages/ui/src/websocketcleanup.tsx");
